import React from "react";
import i18next from "i18next";

type Props = {
  value: number;
  sizeBefore?: number;
  sizeAfter?: number;
  color?: string;
};

const PriceText: React.FC<Props> = ({
  value,
  sizeBefore = 24,
  sizeAfter = 16,
  color,
}) => {
  // Format number according to language
  const locale = i18next.language.startsWith("ar") ? "ar-EG" : "en-US";

  // Convert number to string with 2 decimals
  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);

  // Detect decimal separator for the current locale
  const decimalSeparator = (1.1).toLocaleString(locale).substring(1, 2);

  // Split integer and decimals
  const [before, after] = formatted.split(decimalSeparator);

  return (
    <span
      className={`${color ? `text-[${color}]` : "text-Black"} font-black`}
    >
      <span className={`text-[${sizeBefore}px]`}>{before}</span>
      <span className={`text-[${sizeAfter}px]`}>{decimalSeparator}{after}</span>
    </span>
  );
};

export default PriceText;
